import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

type documentFileExtension =  'pdf' | 'csv' | 'gif' | 'jpg' | 'png' | 'xls' | '' | null;

@Component({
  selector: 'terra-document-file-icon',
  imports: [MatIconModule],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  @switch (extension) {
    @case ('pdf') { <mat-icon class="document-icon" svgIcon="pdf_doc" /> }
    @case ('csv') { <mat-icon class="document-icon" svgIcon="csv_doc" /> }
    @case ('gif') { <mat-icon class="document-icon" svgIcon="gif_doc" /> }
    @case ('jpg') { <mat-icon class="document-icon" svgIcon="jpg_doc" /> }
    @case ('png') { <mat-icon class="document-icon" svgIcon="png_doc" /> }
    @case ('xls') { <mat-icon class="document-icon" svgIcon="xls_doc" /> }
    @default { <mat-icon class="document-icon" svgIcon="any_doc" /> }
  }
`,
  styles: `
  .document-icon {
    height: 40px;
    width: 33px;
  }`, // TODO: make default icon size & get icon size from Input

})
export class DocumentFileIconComponent {
  @Input() extension: documentFileExtension = null;
}
